import { useEffect } from "react"
import { ActionPerformed, PushNotificationSchema, PushNotifications, Token } from "@capacitor/push-notifications"
import { VibratoClient } from "@/lib/vibrato-api"
import { NATIVE_DEVICE_ID, settings } from "@/settings"
import { Capacitor } from "@capacitor/core"

export const useRegisterPushToken = (vibratoClient: VibratoClient, pushStatus: string | null) => {
  useEffect(() => {
    if (!settings.IS_NATIVE_APP) {
      return
    }

    if (!vibratoClient || !pushStatus) {
      console.log("No vibrato client or push status, cannot register push token")
      return
    }

    if (pushStatus != "granted") {
      console.log("Push status is not granted, cannot register push token")
      return
    }

    PushNotifications.register()

    // On success, we should be able to receive notifications
    PushNotifications.addListener("registration", (token: Token) => {
      vibratoClient
        .registerPushNotificationToken({
          token: token.value,
          platform: Capacitor.getPlatform(),
          device_name: NATIVE_DEVICE_ID
        })
        .then(() => {
          console.log(`Push registration success`)
        })
        .catch((error) => {
          console.error(`Error registering push token: ${JSON.stringify(error)}`)
        })
    })

    // Some issue with our setup and push will not work
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    PushNotifications.addListener("registrationError", (error: any) => {
      console.log(`Error on registration: ${JSON.stringify(error)}`)
    })

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener("pushNotificationReceived", (notification: PushNotificationSchema) => {
      console.log(`Push received: ${JSON.stringify(notification)}`)
    })

    // Method called when tapping on a notification
    PushNotifications.addListener("pushNotificationActionPerformed", (notification: ActionPerformed) => {
      console.log(`Push action performed: ${JSON.stringify(notification)}`)
    })
  }, [vibratoClient, pushStatus])

  return null
}
